import { defineNuxtPlugin } from '#imports'
import { setCookie } from '@b2ag/utils/src/cookies'

export default defineNuxtPlugin({
  name: 'runtime theme',
  enforce: 'pre',
  parallel: true,
  hooks: {
    'app:created'() {
      const url = new URL(window.location.href)
      const searchParams = new URLSearchParams(url.search)

      if (searchParams.get('current_theme')) {
        setCookie('current_theme', searchParams.get('current_theme') as string, 1)
        // Supprimer les paramètres après avoir traité le thème et recharger la page
        if (url.search || url.hash) {
          // Conserver uniquement le chemin de base
          window.location.href = `${url.origin}${url.pathname}`
        }
      }
    },
  },
})
